import request from '@/utils/request'

/*
    获取vip列表
 */
function getGoodsVipList(query) {
    return request({
        url: '/admin/goods_vip/list',
        method: 'get',
        params: query
    })
}
